import { RouterStateSnapshot,  ActivatedRouteSnapshot,  Router, Route, CanLoad, CanActivate} from '@angular/router';
import { Injectable, ViewEncapsulation } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../../environments/environment';
import { UsblickCommonEnum } from '../usblick-common-enum';
import { setting } from '../../../../../setting';


@Injectable()
export class AuthorizatedGuard implements CanLoad, CanActivate {
  private module : string;
  public url : string;

  constructor(
    private _router:Router,
    private _auth:AuthService
    ) {
    this.module = environment.module;
    this.url = window.location.href;
  }

  canLoad (route: Route): Observable<boolean> {
    return this.canMethod();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
   return this.canMethod();
  }

  // La sesión vive en la cookie HttpOnly auth_token, que el JS no puede leer:
  // en vez de chequearla, se le pregunta al backend si hay una sesión válida.
  canMethod (): Observable<boolean> {
    if (!setting.ActivatedGuard) {
      return of(true);
    }

    return this._auth.checkSession().pipe(
      map((valid: boolean) => {
        if (!valid) {
          this.letsRedirect();
        }
        return valid;
      }),
      catchError(() => {
        this.letsRedirect();
        return of(false);
      })
    );
  }

  letsRedirect(){
    window.location.href = setting.appUrl + UsblickCommonEnum.redirectQuery + encodeURIComponent(this.url);
  }

}
